export const residentialStatus = [
  {text: 'Жилое', value: true},
  {text: 'Нежилое', value: false}
]

export const residentialStatusAsString = function(type) {
  return residentialStatus.find(it => it.value === type).text
}
